export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail yoki foydalanuvchi nomi',
      invalidEmailOrUsername: "Noto'g'ri e-mail yoki foydalanuvchi nomi",
      invalidPassword: "Noto'g'ri parol",
      noInternetConnection: "Internet bog'lanishi yo'q",
      pageNotFound_title: 'Sahifa Topilmadi',
      password: 'Parol',
      projectManagement: 'Loyiha boshqaruvi',
      serverConnectionFailed: "Serverga bog'lanish xatosi",
      unknownError: "Noma'lum xatolik, qaytadan urinib ko'ring",
    },

    action: {
      logIn: 'Kirish',
    },
  },
};
